<template>
  <div class="">
    <div class="business">
      <!-- 美通海外仓 -->
      <div class="flx-center">
        <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/business/overseas_banner.png) no-repeat center' }"></div>
      </div>

      <div>
        <div class="container">
          <div>
            <div class="button-group">
              <div
                class="button-group-item"
                style="position: absolute; top: 800px"
              >
                <el-button
                  v-for="(item, index) in buttons"
                  :key="index"
                  :class="{ active: activeIndex === index }"
                  @click="setActive(item, index)"
                >
                  <div class="btn-text" style="">
                    {{ item.label }}
                  </div>
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative">
          <div class="business-imgRight">
            <img :src="$ossUrl + 'images/business/circel.png'" alt="" />
          </div>
          <div class="container">
            <div class="service" style="position: relative">
              <div class="business-imgLeft">
                <img :src="$ossUrl + 'images/business/listen.png'" alt="" />
              </div>

              <div
                class="service-text"
                style="padding-top: 70px; margin: 130px 0 0 0px"
              >
                <div>美通海外仓</div>
                <i class="serviceNews"></i>
              </div>
              <div class="flx-center">
                <div class="service-content">
                  为提供更好的物流服务，美通不断整合海外优质资源，在加拿大、美国、墨西哥、英国、比利时、德国、法国、日本建立自营海外仓，面积达
                  80000
                  平方米。美通结合创新智能化物流系统。助力跨境电商智联全球，提供快捷、优质、安全无忧的国际物流服务。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 自营仓 -->
      <div class="service-text-bg" style="padding-bottom: 58px">
        <div class="container">
          <div
            class="service-text"
            style="padding-top: 70px; margin: 130px 0 0 0px"
          >
            <div>自营仓</div>
            <i class="serviceNews"></i>
          </div>
        </div>
        <div
          class="container"
          style="margin-top: 87px; display: flex; position: relative"
        >
          <div class="flx-only-justify-between">
            <div class="proprietaryImg">
              <img
                v-if="activePropsIndex === 0"
                :src="$ossUrl + 'images/business/overSea/background/加拿大.png'"
                alt=""
                style="width: 100%"
              />
              <img
                v-if="activePropsIndex === 1"
                :src="$ossUrl + 'images/business/america_storage.png'"
                alt=""
                style="width: 100%"
              />
              <img
                v-if="activePropsIndex === 2"
                :src="$ossUrl + 'images/business/overSea/background/墨西哥.png'"
                alt=""
                style="width: 100%"
              />
              <img
                v-if="activePropsIndex === 3"
                :src="$ossUrl + 'images/business/overSea/background/英国.png'"
                alt=""
                style="width: 100%"
              />
              <img
                v-if="activePropsIndex === 4"
                :src="$ossUrl + 'images/business/overSea/background/德国.png'"
                alt=""
                style="width: 100%"
              />
            </div>
            <div class="proprietary-buttons">
              <el-row>
                <el-col
                  :span="12"
                  v-for="(button, index) in buttonProps"
                  :key="index"
                >
                  <div
                    class="flx-justify-between"
                    @mouseenter="hovermouse(index)"
                    v-if="hoverIndex"
                    :class="[
                      'buttonPropsBox',
                      { 'proprietary-active': activePropsIndex === index },
                    ]"
                  >
                    <div class="flx-center">
                      <img
                        style="width: 32px; margin-right: 16px"
                        :src="button.icon"
                        alt="icon"
                      />
                      <span class="activeContrySpan">{{ button.contry }}</span>
                    </div>
                    <span class="activeCapitalSpan">{{ button.capital }}</span>
                  </div>

                  <div
                    class="flx-justify-between"
                    @mouseenter="hovermouse(index)"
                    v-else
                    :class="['buttonPropsBox']"
                  >
                    <div class="flx-center">
                      <img
                        style="width: 32px; margin-right: 16px"
                        :src="button.icon"
                        alt="icon"
                      />
                      <span class="activeContrySpan">{{ button.contry }}</span>
                    </div>
                    <span class="activeCapitalSpan">{{ button.capital }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务功能 -->
      <div class="container">
        <div class="service" style="padding: 100px 0">
          <div class="service-text">
            <div>服务功能</div>
            <i class="serviceNews"></i>
          </div>
          <div style="padding: 0 100px">
            <div
              class="flx-justify-between serviceBox"
              style="margin-top: 130px"
            >
              <div class="serviceBoxTitle">
                <span
                  ><img
                    :src="
                      $ossUrl + 'images/business/overSea/service/LOGO1.png'
                    "
                /></span>
                <span>暂存中转服务</span>
              </div>
              <div class="serviceBoxContent">
                美通海外仓为跨境卖家提供暂存货物服务，不仅可以帮助卖家避免较高的仓租费用，还可降低部分环节的延误风险。
              </div>
            </div>
            <div class="serviceBoxLine"></div>
            <div
              class="flx-justify-between serviceBox"
              style="margin-top: 60px"
            >
              <div class="serviceBoxTitle">
                <span
                  ><img
                    :src="
                      $ossUrl + 'images/business/overSea/service/LOGO2.png'
                    "
                /></span>
                <span>一件代发</span>
              </div>
              <div class="serviceBoxContent">
                提供仓储出入库服务，自有系统可对接四十多个电商平台，从下单到妥投全程自动化、可视化。
              </div>
            </div>
            <div class="serviceBoxLine"></div>
            <div
              class="flx-justify-between serviceBox"
              style="margin-top: 60px"
            >
              <div class="serviceBoxTitle">
                <span
                  ><img
                    :src="
                      $ossUrl + 'images/business/overSea/service/LOGO3.png'
                    "
                /></span>
                <span>增值服务</span>
              </div>
              <div class="serviceBoxContent">
                自营仓库可根据不同客户的需求提供，如开箱、复核、转送、检测、售后维修等其他服务。
              </div>
            </div>
            <div class="serviceBoxLine"></div>
            <div
              class="flx-justify-between serviceBox"
              style="margin-top: 60px"
            >
              <div class="serviceBoxTitle">
                <span
                  ><img
                    :src="
                      $ossUrl + 'images/business/overSea/service/LOGO4.png'
                    "
                /></span>
                <span>退件服务</span>
              </div>
              <div class="serviceBoxContent">
                提供退件的入库、暂存、重派、销毁等服务，全线上登记，透明公开
              </div>
            </div>
            <div class="flx-center" style="margin-top: 100px">
              <div
                class="serviceBoxEnd"
                :style="{
                  background:
                    'url(' + $ossUrl + 'images/business/aaf.jpg) no-repeat ',
                  backgroundSize: 'cover',
                }"
              >
                <!-- <img class="serviceBoxImg1" src="@/assets/images/business/listen.png" alt="">
              <img class="serviceBoxImg2" src="@/assets/images/business/aaf_Icon_green.jpg" alt="">
              <span>海外 <i>130</i> 多家合作车队，涵盖全种类车型及船运，从效率到成本全方位满足客户需求。</span>
              <span>专业运营团队，多年海外仓实地工作经验，快速精准解决异常问题</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 运输流程 -->
      <!-- <div class="service-text-bg" style="padding-bottom: 80px;">
          
          <div class="container " >
            <div class="service-text" style="padding-top: 100px;margin:0 0 0 0px;">
            <div >运输流程</div><i class="serviceNews"></i>
          </div>
          </div>
         
          <div class="container " style="margin-top: 70px;position: relative;">
            <el-row>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation1.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">01</div>
                      <div class="transportationProContent">客户系统下单</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation2.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">05</div>
                      <div class="transportationProContent">到达监管仓</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation3.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">02</div>
                      <div class="transportationProContent">包裹装车发送至口岸</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation4.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">06</div>
                      <div class="transportationProContent">监管仓清关</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation5.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">03</div>
                      <div class="transportationProContent">口岸换装报关</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation6.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">07</div>
                      <div class="transportationProContent">尾程灵活派送</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation7.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">04</div>
                      <div class="transportationProContent">出境</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation8.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">08</div>
                      <div class="transportationProContent">AMZ仓库、第三方海外仓收货并上架</div>
                    </div>
                </div>
              </el-col>
            
              
            </el-row>
       
         
          </div>
        </div>  -->
    </div>
  </div>
</template>
<script>
/**
 * Index-1 component
 */
export default {
  name: "business",
  components: {},
  data() {
    return {
      hoverIndex: true,
      activeName: "second",
      activeIndex: 0, // 默认选中第一个按钮
      buttons: [
        { label: "海外仓", transportMode: "OCEAN" },
        { label: "头程海运", transportMode: "AIR" },
        { label: "头程卡航", transportMode: "RAIL" },
        { label: "头程空运", transportMode: "ROAD" },
      ],
      activePropsIndex: 0,
      buttonProps: [
        {
          contry: "加拿大",
          capital: "温哥华/多伦多",
          icon: this.$ossUrl + "images/business/overSea/CA.png",
        },
        {
          contry: "美国",
          capital: "洛杉矶/芝加哥",
          icon: this.$ossUrl + "images/business/overSea/US.png",
        },
        {
          contry: "墨西哥",
          capital: "墨西哥",
          icon: this.$ossUrl + "images/business/overSea/MX.png",
        },
        {
          contry: "英国",
          capital: "伦敦",
          icon: this.$ossUrl + "images/business/overSea/GB.png",
        },
        // { contry: '比利时',capital:'烈日',icon:require('@/assets/images/business/overSea/BE.png')},
        {
          contry: "德国",
          capital: "科隆",
          icon: this.$ossUrl + "images/business/overSea/DE.png",
        },
        // { contry: '法国',capital:'巴黎',icon:require('@/assets/images/business/overSea/FR.png')},
        // { contry: '日本',capital:'大阪府',icon:require('@/assets/images/business/overSea/JP.png')},
      ],
    };
  },
  methods: {
    hovermouse(index) {
      this.activePropsIndex = index;
      this.hoverIndex = false;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    setActive(item, index) {
      if (index === 1) {
        this.$router.push({
          name: "sea",
        });
      } else if (index === 2) {
        this.$router.push({
          name: "road",
        });
      } else if (index === 3) {
        this.$router.push({
          name: "air",
        });
      } else {
        this.$router.push({
          name: "business",
        });
      }
      // this.activeIndex = index;
    },
  },
};
</script>
<style src="./index.css" scoped></style>
